import control from "./control";

/**
 * @class Layout
 * @description 布局组件核心类
 * @example
 * import lalyout from "./lalyout";
 *
 * export default {
 *    name: "xxxx", 组件 name
 *    ctrlCaption: "xxx", // 组件中文名称
 *    mixins: [lalyout],
 *    ...
 * }
 */
export default {
  mixins: [control],
  /**
   * @memberof Layout
   * @name Props 属性
   */
  props: {},
  design: {
    //设计器是是否在组件上产生遮罩
    isMask: false,
    toolButtons: {
      //设计器是是否在组件左上角是否有查看按钮
      infoButton: true,
      //设计器是否在组件左上角显示设置按钮
      dragButton: true,
      //设计器是是否在组件左上角是否有移除按钮
      removeButton: true,
      //设计器是是否在组件左上角是否有设置
      settingButton: true
    },
    settingMenus(){
      return [
        {
          text: "保存为业务组件",
          command: "save-business",
          handler: function () {
            this.$designer.saveBusinessComponentSingle(this, "");
          },
          hidden() {
            return !this?.$designer.$allowSaveBusinessControl;
          }
        }
      ]
    } 
  }
};
